const MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

/** Fechas ISO sin zona: se parsean a mano para que no se recorran un día. */
export function parseDate(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}

export function shortDate(iso: string | null): string {
  if (!iso) return '—'
  const d = parseDate(iso)
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`
}

export function longDate(iso: string | null): string {
  if (!iso) return '—'
  const d = parseDate(iso)
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`
}

export function monthLabel(period: string): string {
  const [y, m] = period.split('-').map(Number)
  return `${MONTHS[m - 1]} ${String(y).slice(2)}`
}

export function daysBetween(a: string, b: string): number {
  return Math.round((parseDate(b).getTime() - parseDate(a).getTime()) / 86_400_000)
}

/** "en 3 días" / "hace 2 días" / "hoy" — lenguaje humano para el panel de hoy. */
export function relativeDays(iso: string | null, today: string): string {
  if (!iso) return '—'
  const diff = daysBetween(today, iso)
  if (diff === 0) return 'hoy'
  if (diff === 1) return 'mañana'
  if (diff === -1) return 'ayer'
  return diff > 0 ? `en ${diff} días` : `hace ${Math.abs(diff)} días`
}

export function todayIso(): string {
  const d = new Date()
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

const MONTHS_LONG = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
]

/** Iniciales de día, de lunes a domingo: la semana laboral primero. */
const WEEKDAY_INITIALS = ['D', 'L', 'M', 'M', 'J', 'V', 'S']

/** "2026-09" → "Septiembre 2026". Para el encabezado de la vista de mes. */
export function monthTitle(period: string): string {
  const [y, m] = period.split('-').map(Number)
  return `${MONTHS_LONG[m - 1]} ${y}`
}

/** "2026-09-14" → "2026-09". */
export function periodOf(iso: string): string {
  return iso.slice(0, 7)
}

/** Día del mes de una fecha ISO, sin pasar por `Date` y su zona horaria. */
export function dayOf(iso: string): number {
  return Number(iso.slice(8, 10))
}

export function daysInMonth(period: string): number {
  const [y, m] = period.split('-').map(Number)
  return new Date(y, m, 0).getDate()
}

/** Inicial del día de la semana para el día `d` del periodo. */
export function weekdayInitial(period: string, d: number): string {
  const [y, m] = period.split('-').map(Number)
  return WEEKDAY_INITIALS[new Date(y, m - 1, d).getDay()]
}

export function isWeekend(period: string, d: number): boolean {
  const [y, m] = period.split('-').map(Number)
  const wd = new Date(y, m - 1, d).getDay()
  return wd === 0 || wd === 6
}

/** Corre un periodo `n` meses (puede ser negativo). */
export function addMonths(period: string, n: number): string {
  const [y, m] = period.split('-').map(Number)
  const d = new Date(y, m - 1 + n, 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

/** Fecha ISO del día `d` dentro del periodo. */
export function isoOfDay(period: string, d: number): string {
  return `${period}-${String(d).padStart(2, '0')}`
}
